export function classNames(cons: Record<string, boolean | undefined>, ...always: string[]): string {
  const out = always.slice();
  for (const k of Object.keys(cons)) {
    if (cons[k]) {
      out.push(k);
    }
  }

  return out.join(' ');
}
